import React from 'react';
import ResponseTypo from './ResponseTypo';
import { NavCard, NavCardSkeleton } from '../../common/NavCard';
import { useCourseFinderLinks } from '../../../hooks/useCourseFinderLinks';
import '../../../styles/story/story.css';

/** 젭스 스토리 - 커리큘럼 바로가기 영역 */
export const StoryCourse = () => {
  const { links, loading } = useCourseFinderLinks();

  return (
    <section className="p-5 lg:py-14">
      <div className="lg:m-auto lg:max-w-[1024px]">
        <ResponseTypo variant_lg="h3" variant_sm="h5" className="color-red">
          바이블 스토리 암송은 물론
          <br />
          회화, A.D 문법까지 아우르는 <br className="lg:hidden" />전 연령
          커리큘럼을 제공합니다.
        </ResponseTypo>

        {/* 코스 찾기 링크 카드 목록 */}
        <div className="mt-5 grid grid-cols-1 justify-center gap-4 lg:mt-9 lg:grid-cols-3">
          {loading
            ? Array.from({ length: 3 }, (_, i) => <NavCardSkeleton key={i} />)
            : links.map((item) => (
                <NavCard
                  key={item.id}
                  to={item.linkUrl}
                  imageSrc={item.iconImageUrl ?? undefined}
                  topText={item.description ?? undefined}
                  bottomText={item.name}
                />
              ))}
        </div>
      </div>
    </section>
  );
};
